import * as React from 'react';

interface IStepProps {
  stepNumber: number,
  currentStep: number
}

export default class Step extends React.Component<IStepProps> {
  render() {
    return (
      <div key={this.props.stepNumber} style={{ display: this.props.stepNumber == this.props.currentStep ? "block" : "none" }}>
        {this.props.children}
      </div>
    );
  }
}
